import React, { useState } from 'react'
import Logo from '../../assets/logo.png'
import bars from '../../assets/bars.png'
import { useLocation, useNavigate } from 'react-router-dom';
import './header.css'
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';


function Header(props) {
    const mobile = window.innerWidth<=768 ? true: false;
    const [menuOpened, setMenuOpened] = useState(false);  
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        Cookies.remove('token');
        Cookies.remove('name');
        Cookies.remove('type');
        navigate('/');
        props.setIsLoggedIn(false); 
      };

      if (location.pathname === '/') {
        return (
          <div className="header">
              <img src={Logo} alt="" className='logo' />
          </div>
        )
      }

  return (
    <div className="header">
        <Link to='/home'>
            <img src={Logo} alt="" className='logo'/>
        </Link>
        {menuOpened === false && mobile === true ?(
          <div style={{backgroundColor:'#fff', padding:'0.5rem', borderRadius:'5px', marginTop:'10px'}}
          onClick={()=> setMenuOpened(true)}
          ><img src={bars} alt='' style={{width:'1.5rem', height: '1.5rem'}}/></div>
        ):(
        <ul className='header-menu'>
            <li className='cross-mark' onClick={()=> setMenuOpened(false)}>x</li>
            <li onClick={()=> setMenuOpened(false)}>
            <Link
              to='/home'
              >Home</Link>
            </li>
            <li onClick={()=> setMenuOpened(false)}>
              <Link
              to='/transactions'
              >Transactions</Link>
            </li>
            {Cookies.get('type') === '0' &&
              <>
              <li onClick={()=> setMenuOpened(false)}>
                <Link
                    to='/update-cash-data'
                >Update Cash Data</Link>
              </li>
              <li onClick={()=> setMenuOpened(false)}>
                <Link
                  to='/stats'
                  >Stats</Link>
              </li>
              </>
            }
            <li onClick={() => {handleLogout(); setMenuOpened(false);}}>
                Logout
            </li>
        </ul>)}
    </div>
  )
}

export default Header
